import React, { useEffect, useState } from 'react';
import { Check, Globe, X } from 'lucide-react';
interface LanguageModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectLanguage: (code: string) => void;
}
const LANGUAGES = [{
  code: 'en',
  label: 'English',
  native: 'English',
  flag: '🇬🇧'
}, {
  code: 'my',
  label: 'Melayu',
  native: 'Bahasa Melayu',
  flag: '🇲🇾'
}, {
  code: 'zh',
  label: 'Chinese',
  native: '简体中文',
  flag: '🇨🇳'
}];
export function LanguageModal({
  isOpen,
  onClose,
  onSelectLanguage
}: LanguageModalProps) {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      // Prevent body scroll
      document.body.style.overflow = 'hidden';
    } else {
      const timer = setTimeout(() => setIsVisible(false), 300);
      document.body.style.overflow = 'unset';
      return () => clearTimeout(timer);
    }
  }, [isOpen]);
  if (!isVisible && !isOpen) return null;
  return <div className={`fixed inset-0 z-[100] flex items-center justify-center p-4 transition-all duration-300 ${isOpen ? 'opacity-100 backdrop-blur-sm bg-black/30' : 'opacity-0 backdrop-blur-none bg-transparent'}`} data-id="element-35">
      <div className={`bg-white w-full max-w-md rounded-3xl shadow-2xl overflow-hidden transform transition-all duration-500 ${isOpen ? 'translate-y-0 scale-100' : 'translate-y-8 scale-95'}`} data-id="element-36">
        {/* Header with visual pointer hint */}
        <div className="relative bg-teal-600 p-8 text-center overflow-hidden" data-id="element-37">
          {/* Decorative circles */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-teal-500/20 rounded-full -translate-y-1/2 translate-x-1/3 blur-3xl" data-id="element-38" />
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-teal-400/20 rounded-full translate-y-1/3 -translate-x-1/3 blur-2xl" data-id="element-39" />

          <div className="relative z-10" data-id="element-40">
            <div className="w-16 h-16 bg-white/10 rounded-2xl flex items-center justify-center mx-auto mb-4 backdrop-blur-md border border-white/20 shadow-inner" data-id="element-41">
              <Globe className="w-8 h-8 text-white" data-id="element-42" />
            </div>
            <h2 className="text-2xl font-bold text-white mb-2" data-id="element-43">
              Welcome to Hands
            </h2>
            <p className="text-teal-100" data-id="element-44">
              Please select your preferred language
            </p>
          </div>

          {/* Close button */}
          <button onClick={onClose} className="absolute top-4 right-4 p-2 text-white/70 hover:text-white hover:bg-white/10 rounded-full transition-colors" aria-label="Close modal" data-id="element-45">
            <X className="w-5 h-5" data-id="element-46" />
          </button>
        </div>

        {/* Language Options */}
        <div className="p-6 space-y-3" data-id="element-47">
          {LANGUAGES.map(lang => <button key={lang.code} onClick={() => onSelectLanguage(lang.code)} className="w-full group relative flex items-center p-4 rounded-xl border border-gray-100 hover:border-teal-500 hover:bg-teal-50/30 transition-all duration-200 text-left" data-id="element-48">
              <span className="text-2xl mr-4 filter drop-shadow-sm" data-id="element-49">
                {lang.flag}
              </span>
              <div className="flex-1" data-id="element-50">
                <div className="font-semibold text-gray-900 group-hover:text-teal-700 transition-colors" data-id="element-51">
                  {lang.native}
                </div>
                <div className="text-xs text-gray-500 font-medium" data-id="element-52">
                  {lang.label}
                </div>
              </div>
              <div className="w-8 h-8 rounded-full border border-gray-200 flex items-center justify-center group-hover:border-teal-500 group-hover:bg-teal-500 transition-all" data-id="element-53">
                <Check className="w-4 h-4 text-white opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-54" />
              </div>
            </button>)}
        </div>

        {/* Footer hint */}
        <div className="px-6 pb-6 text-center" data-id="element-55">
          <p className="text-xs text-gray-400" data-id="element-56">
            You can always change this later from the top right menu
          </p>

          {/* Visual arrow pointing to top right */}
          <div className="absolute -top-12 right-8 hidden md:block animate-bounce duration-[2000ms]" data-id="element-57">
            <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-white drop-shadow-lg transform rotate-12" data-id="element-58">
              <path d="M30 50V10M30 10L15 25M30 10L45 25" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" data-id="element-59" />
            </svg>
          </div>
        </div>
      </div>
    </div>;
}